import * as React from "react";
const SvgCheckIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={10} fill="none" viewBox="0 0 12 10" {...props}><path d="M0 5.383 4.11 9.5 12 1.617 10.867.5 4.11 7.25 1.117 4.258z" /></svg>;
export default SvgCheckIcon;